import { Box, Typography } from "@mui/material";
import StepColumn from "./StepColumn";

const DesktopSteps = ({ stepsData }) => {
  return (
    <Box sx={{ position: "relative" }}>
      {/* The Main Horizental Line*/}
      <Box
        sx={{
          position: "absolute",
          top: 28, // Half of the Circle (Circle is 56)
          left: "11.8%",
          right: "11.5%",
          height: "1px",
          backgroundColor: "#0000001F",
          zIndex: 0,
        }}
      />

      {/* Columns */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          gap: "16px", // Same as the Cards
          position: "relative",
          zIndex: 2,
        }}
      >
        {stepsData.map((step, index) => (
          <StepColumn
            key={step.number}
            step={step}
            isLast={index === stepsData.length - 1}
          />
        ))}
      </Box>
    </Box>
  );
};

export default DesktopSteps;
